<sdc-bo-dialog
  [headerTitle]="(selectedServiceCharge ? 'Edit' : 'Add') + ' Service Charge'"
  [styleClass]="['variant-prominent-title']"
  data-cy="service-charge-modal">
  <form [formGroup]="form">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <div class="mb-4">
          <label for="id">ID <span class="mandatory-asterisk">*</span></label>
          <input
            [attr.data-cy]="'service-charge-modal-id-input'"
            [ngClass]="{
              disabled: !!selectedServiceCharge,
              'invalid-input':
                form.get('id')?.invalid && form.get('id')?.touched,
            }"
            type="text"
            class="sc-input"
            id="id"
            formControlName="id" />
          @if (form.get('id')?.invalid && form.get('id')?.touched) {
            <span class="text-[80%] error-color"> ID is required </span>
          }
        </div>
      </div>
      <div>
        <div class="mb-4">
          <label for="name"
            >Name <span class="mandatory-asterisk">*</span></label
          >
          <input
            type="text"
            class="sc-input"
            id="name"
            [attr.data-cy]="'service-charge-modal-name-input'"
            [ngClass]="{
              'invalid-input':
                form.get('name')?.invalid && form.get('name')?.touched,
            }"
            formControlName="name" />
          @if (form.get('name')?.invalid && form.get('name')?.touched) {
            <span class="text-[80%] error-color"> Name is required </span>
          }
        </div>
      </div>
    </div>
    <div class="mb-4">
      <label class="mb-2">
        Description <span class="mandatory-asterisk">*</span></label
      >
      <div class="sc-group">
        <input
          [attr.data-cy]="'service-charge-modal-amount-input'"
          type="number"
          min="0"
          class="sc-input"
          [ngClass]="{
            'invalid-input':
              form.get('amount')?.invalid && form.get('amount')?.touched,
          }"
          formControlName="amount" />
        <select class="sc-select" formControlName="amountUnit">
          <option value="USD">USD</option>
          <option value="percent">percent</option>
        </select>
        <span class="sc-addon">per</span>
        <select class="sc-select" formControlName="applyPer">
          <option value="ticket">ticket</option>
          <option value="transaction">transaction</option>
        </select>
        <span class="sc-addon">up to</span>
        <input
          [attr.data-cy]="'service-charge-modal-cap-amount-input'"
          type="number"
          min="0"
          class="sc-input"
          [ngClass]="{
            'invalid-input':
              form.get('capAmount')?.invalid && form.get('capAmount')?.touched,
          }"
          formControlName="capAmount" />
        <select class="sc-select" formControlName="capAmountUnit">
          @if (form.get('applyPer')?.value !== 'transaction') {
            <option value="tickets">tickets</option>
          }
          <option value="USD">USD</option>
        </select>
      </div>
      <div class="description-preview">
        {{ getDescriptionPreview() }}
      </div>
      @if (form.get('amount')?.invalid && form.get('amount')?.touched) {
        <span class="text-[80%] error-color">
          Amount must be greater than or equal to 0
        </span>
      }
      @if (form.get('capAmount')?.invalid && form.get('capAmount')?.touched) {
        <span class="text-[80%] error-color">
          Cap amount must be greater than or equal to 0
        </span>
      }
    </div>
  </form>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button
      data-cy="service-charge-modal-cancel-button"
      variant="secondary"
      (onClick)="dismissModal()">
      Cancel
    </sdc-button>
    <sdc-button
      data-cy="service-charge-modal-save-button"
      variant="primary"
      [disabled]="!form.valid || isLoading"
      (onClick)="save()">
      Save
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
